import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

const StepVehiclechange = (props) => {
  return (
    <Step
      id="vehiclechange"
      title="Vehicle Changing"
      nonext
      skip={(formdata) =>
        formdata.vehicles[props.state.vehicle_index].plate === '13cabs' ||
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        !props.stateconfig().oldcar ||
        formdata.vehicles[props.state.vehicle_index].carbuy
      }>
      <Typography variant="body1" class="formQuestion">
        Is this vehicle replacing an existing vehicle?
      </Typography>
      <ButtonField
        id="car_replace"
        label="Yes"
        value={true}
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="car_replace"
        label="No"
        value={false}
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepVehiclechange;
